import { render, staticRenderFns } from "./AddWin.vue?vue&type=template&id=2ddf560c&"
import script from "./AddWin.vue?vue&type=script&lang=js&"
export * from "./AddWin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports